import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconChatBubbleOutline = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconChatBubbleOutline",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m240-240-92 92q-19 19-43 9t-25-38v-623q0-33 24-56t56-24h640q33 0 57 24t23 56v480q0 33-23 57t-57 23zm-34-80h594v-480H160v525zm-46 0v-480z"
  })
}));
IconChatBubbleOutline.displayName = 'IconChatBubbleOutline';